
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum QueryType {
	TaskAction = 0,
	Taskflow = 1,
	Company = 2,
	Order = 3,
	ProductPlan = 4,
	Product = 5,
	OrderCancellation = 6,
	OrderWarning = 7,
	OrderLine = 8,
	OrderProductPlanDiscontinuation = 9,
	Settlement = 10,
	Transfer = 11
}
export namespace QueryType {
	export function getKeys(): Map<QueryType, string> {
		return new Map([[0, 'TaskAction'], [1, 'Taskflow'], [2, 'Company'], [3, 'Order'], [4, 'ProductPlan'], [5, 'Product'], [6, 'OrderCancellation'], [7, 'OrderWarning'], [8, 'OrderLine'], [9, 'OrderProductPlanDiscontinuation'], [10, 'Settlement'], [11, 'Transfer']]);
	}
}
